module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-settings/123assets/fonts/1a22f0004fff1f6e757a2a38fbaa8ff7.svg";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.svg
// module id = 748
// module chunks = 4